<template>
    <v-flex xs12>
        <div v-if="loading">
            <v-progress-linear height="2" :indeterminate="true"> Cargando comentarios...</v-progress-linear>
        </div>
        <div v-else>
            <v-flex xs12 mt-4 pt-2 v-if="replies && replies.length > 0">

                <h3 class="font-weight-light mb-3">Comentarios:</h3>

                <v-flex xs12 v-for="reply in items">
                    <rating-reply :reply="reply"></rating-reply>
                </v-flex>

                <v-flex xs12 text-center v-if="moreLink">
                    <v-sheet height="3">
                        <v-progress-linear
                                v-if="loadingMore"
                                height="2"
                                :indeterminate="true"
                        > Cargando comentarios...</v-progress-linear>
                    </v-sheet>

                    <v-btn
                            small
                            depressed
                            rounded
                            @click="getMoreReplies"
                            :disabled="loadingMore"
                    >Cargar mas comentarios</v-btn>
                </v-flex>

            </v-flex>

            <v-flex v-else text-center mt-4 pt-2>
                <h4 class="font-weight-light">Esta calificación aún no tiene comentarios.</h4>
            </v-flex>
        </div>
    </v-flex>

</template>

<script>
    import RatingReply from './RatingReply.vue'
    import {subscribeToPublicChannelEvents, leaveChannel} from '@/utils/Sockets'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'

    export default{
        components: {RatingReply},
        props: ['ratingId'],
        data(){
            return {
                moreItemsLink: null,
                loading: true,
                loadingMore: false,
                replies: [],
                moreLink: null,
            }
        },
        beforeDestroy(){
            var vm = this
            leaveChannel(`rating.${vm.ratingId}`)
        },
        mounted(){
            var vm = this
            vm.getReplies()
            subscribeToPublicChannelEvents(`rating.${vm.ratingId}`, {
                CommentAddedToRating: vm.onCommentAdded,
                CommentDeletedFromRating: vm.onCommentDeleted
            })
        },
        computed: {
            items(){
                var vm = this
                return vm.replies.sort((a, b) => {
                    return new Date(b.created_at) - new Date(a.created_at);
                })
            }
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            async getReplies(url = ''){

                var vm = this
                if (!vm.ratingId) {
                    throw new Error('Rating ID not set')
                }

                vm.loading = url ? false : true
                vm.loadingMore = url ? true : false
                const response = url.length ? await ApiUtils.makeGet(url) : await ApiUtils.makeGet(`public/providers/rating/${vm.ratingId}/replies`)
                vm.loading = false
                vm.loadingMore = false

                if (!response.ok) {
                    vm.showSnackBar('Ocurrió un error cargando los comentarios.')
                    return
                }

                const json = await response.json()

                vm.moreLink = json.result.replies.next_page_url
                if(json.result.replies.data.length > 0 ){
                    vm.replies = vm.replies.concat(json.result.replies.data)
                }

            },
            onCommentAdded(comment){
                this.replies.push(comment.rating.new_reply)
            },
            onCommentDeleted(comment){
                var vm = this

                var commentId = comment.rating.deleted_reply.id
                const index = vm.replies.findIndex(reply => reply.id === commentId)


                if(index !== -1){
                    vm.replies.splice(index, 1)
                }
            },
            getMoreReplies(){
                var vm = this
                if (vm.loading || !vm.moreLink) return
                vm.getReplies(vm.moreLink)

            }
        }
    }
</script>
